import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        marginTop: theme.spacing(3),
    },
    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1),
        },
    },
    submitButton: {
        marginTop: theme.spacing(0.5),
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        width: '100%',

        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    keepSigned: {
        display: 'flex',
        alignItems: 'center',
    },
    keepSignedCheckbox: {
        marginLeft: '-14px',
    },
}));
